import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const ActualizarPagosWeb = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const btnCancela = useRef();
  const btnAcpta = useRef();
  const txtFecha = useRef();
  const cmbCuentaBan = useRef("");
  const txtNumDocumento = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [desde, setDesde] = useState(0);

  const procesarCambio = (body) => {
    const endpoint = `${op.conexion}/api/Caja_Ingreso/cambiardatospagoweb`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);

          if (response.data) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Se Generaron Cambios Satisfactoriamente en el Pago Web.",
              icono: "exito",
            });
            setDesde(3);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setDesde(0);
  };

  const handleCloseSi = () => {
    let body = {
      fec: txtFecha.current.value,
      idcta:
        cmbCuentaBan.current.value === "" || cmbCuentaBan.current.value === "0"
          ? props.data.idcuentabanco
          : cmbCuentaBan.current.value,
      idpago: props.data
        ? props.data.idpagoweb !== null
          ? parseInt(props.data.idpagoweb)
          : "0"
        : "0",
      numdoc: txtNumDocumento.current.value.trim().toUpperCase(),
      tipo: props.tipopago,
      numtran: props.data
        ? props.data.numtran !== null
          ? parseInt(props.data.numtran)
          : "0"
        : "0",
    };
    procesarCambio(body);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 3) {
      props.onHideAcepta();
    } else if (desde === 2) {
      props.onHideCancela();
    }
    blanquear();
  };

  const cancelar = () => {
    blanquear();

    props.onHideCancela();
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputNumDocumento") {
        txtFecha.current.focus();
      } else if (event.target.id === "inputFecha") {
        if (txtFecha.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else {
          cmbCuentaBan.current.focus();
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputFecha") {
        if (txtFecha.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = () => {
    var sigue = true;
    setDesde(0);
    if (
      txtNumDocumento.current.value.trim() === "" ||
      txtNumDocumento.current.value.trim() === "0"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe suministrar el número del documento.",
        icono: "informacion",
      });
      txtNumDocumento.current.focus();
      sigue = false;
    } else if (txtFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Fecha Invalida",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      cmbCuentaBan.current.value.trim() === "0" ||
      cmbCuentaBan.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe suministrar la cuenta bancaria.",
        icono: "informacion",
      });
      cmbCuentaBan.current.focus();
      sigue = false;
    }
    if (sigue) {
      setDesde(1);
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Está Seguro de Cambiar los Datos de  del Pago Web?.",
        icono: "confirmacion",
      });
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ backgroundColor: "rgb(28, 27, 23,0.5)" }}
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        txtNumDocumento.current.value = props.data
          ? props.data.nrodocumento !== null
            ? props.data.nrodocumento.trim()
            : ""
          : "";
        txtFecha.current.value = props.data
          ? props.data.fecha !== null
            ? moment(props.data.fecha).format("YYYY-MM-DD")
            : ""
          : "";
        cmbCuentaBan.current.value = props.data
          ? props.data.idcuentabancaria !== null
            ? parseInt(props.data.idcuentabancaria)
            : 0
          : 0;
        txtNumDocumento.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant modal-header">
        <div className="fw-bold text-light">
          <h3>{props.operacion === 2 ? "Modificando..." : ""}</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="row mx-auto">
          <div class="input-group input-group-sm mb-2 col-md-6">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Documento:
              </span>
            </div>
            <input
              type="text"
              autoComplete="off"
              name="codigo"
              ref={txtNumDocumento}
              className="form-control form-control-sm"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              id="inputNumDocumento"
            />
          </div>

          <div class="input-group input-group-sm mb-2 col-md-6">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Fecha:
              </span>
            </div>
            <input
              type="date"
              className="form-control form-control-sm"
              ref={txtFecha}
              id="inputFecha"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
            />
          </div>

          <div class="input-group input-group-sm mb-2 col-md-12">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Cuenta:
              </span>
            </div>
            <select
              name=""
              ref={cmbCuentaBan}
              defaultValue={"0"}
              className="form-control form-control-sm"
            >
              <option key="0" value="0">
                --Seleccione--
              </option>
              {props.cuentabancaria &&
                props.cuentabancaria.map((cta) => (
                  <option
                    key={cta.idcuentabancaria}
                    value={cta.idcuentabancaria}
                  >
                    {cta.nombre + " " + cta.cuentabancaria}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcpta}
          onClick={onChangeValidar}
          className="btn btn-sm btn-success rounded-pill"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ingresos/modalActuVerificacion.js